"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _CountryListing = _interopRequireDefault(require("./CountryListing"));
var _RegionalOfficeListing = _interopRequireDefault(require("./RegionalOfficeListing"));
var _OtherCountryOfficeListing = _interopRequireDefault(require("./OtherCountryOfficeListing"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: {
      marginTop: '8px'
    },
    currentLocation: {
      fontWeight: 900,
      fontSize: '20px',
      fontStyle: 'normal',
      lineHeight: 1.2,
      marginBottom: '8px',
      letterSpacing: '1px',
      textTransform: 'uppercase'
    },
    countryWrapper: {
      marginBottom: '40px',
      paddingBottom: '20px',
      borderBottom: "1px solid ".concat(theme.palette.grey[400])
    },
    otherRegion: {
      lineHeight: 1.5,
      marginBottom: '24px',
      fontWeight: 900
    },
    countryList: {
      padding: '0px',
      margin: '0px',
      borderBottom: "1px solid ".concat(theme.palette.grey[400]),
      marginBottom: '40px !important',
      paddingBottom: '40px !important',
      listStyle: 'none',
      columns: '4 100px',
      columnGap: '40px',
      fontWeight: 900,
      fontSize: '14px'
    }
  };
});
var OfficeListing = function OfficeListing(props) {
  var currentRegion = props.currentRegion,
    allRegionsNames = props.allRegionsNames,
    otherRegionsText = props.otherRegionsText,
    allRegionDetails = props.allRegionDetails,
    anchorId = props.anchorId;
  var classes = useStyles();
  return __jsx("div", {
    id: anchorId,
    className: classes.wrapper
  }, __jsx(_core.Grid, {
    container: true,
    className: classes.countryWrapper
  }, currentRegion && __jsx(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.currentLocation
  }, "YOUR LOCATION: ", currentRegion.name), otherRegionsText && __jsx(_core.Grid, {
    item: true,
    xs: 12,
    className: classes.otherRegion
  }, __jsx(_core.Link, {
    href: "".concat("#otherRegion")
  }, otherRegionsText)), __jsx(_react.default.Fragment, null, (currentRegion === null || currentRegion === void 0 ? void 0 : currentRegion.entities) && currentRegion.entities.map(function (item, index) {
    return __jsx(_core.Grid, {
      item: true,
      xs: 12,
      key: index
    }, __jsx(_RegionalOfficeListing.default, item));
  }))), __jsx("ul", {
    className: classes.countryList,
    id: "otherRegion"
  }, allRegionsNames && allRegionsNames.map(function (items, index) {
    return __jsx("li", {
      key: index
    }, __jsx(_CountryListing.default, items));
  })), __jsx(_react.default.Fragment, null, allRegionDetails && allRegionDetails.map(function (item, index) {
    return __jsx(_core.Grid, {
      item: true,
      xs: 12,
      key: index
    }, __jsx(_OtherCountryOfficeListing.default, item));
  })));
};
var OfficeListingEditConfig = {
  emptyLabel: 'Configure a Worldwide Office List',
  isEmpty: function isEmpty(props) {
    if (props.currentRegion && props.allRegionDetails && props.allRegionDetails.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/worldwideofficelisting')(OfficeListing, OfficeListingEditConfig);
exports.default = _default;